var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _polygon, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Greece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M26,13h14.695c-1.275-1.931-2.883-3.615-4.731-5H26V13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M26,22h17.899c-0.173-1.746-0.59-3.416-1.183-5H26V22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M43.899,26H26h-1h-8h-4H4.101c0.173,1.746,0.59,3.416,1.183,5h37.431 C43.309,29.416,43.726,27.746,43.899,26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M40.695,35H7.305c1.275,1.931,2.883,3.615,4.731,5h23.927C37.812,38.615,39.42,36.931,40.695,35z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M35.964,8C33.127,5.875,29.72,4.47,26,4.101V8H35.964z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M26,17h16.716c-0.529-1.415-1.201-2.758-2.021-4H26V17z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M26,26h17.899C43.964,25.342,44,24.675,44,24s-0.036-1.342-0.101-2H26V26z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M42.716,31H5.284c0.529,1.415,1.201,2.758,2.021,4h33.39C41.515,33.758,42.186,32.415,42.716,31z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M13,17H5.284C4.468,19.182,4,21.533,4,24c0,0.675,0.036,1.342,0.101,2H13V17z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M13,7.305C10.738,8.799,8.799,10.738,7.305,13H13V7.305z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3f51b5",
    points: "26,17 25,17 17,17 17,26 25,26 26,26 26,22"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M25,13h1V8V4.101C25.342,4.036,24.675,4,24,4c-2.467,0-4.818,0.468-7,1.284V13H25z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M35.964,40H12.036c3.339,2.501,7.471,4,11.964,4S32.625,42.501,35.964,40z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M13,26h4v-9h8h1v-4h-1h-8V5.284c-1.415,0.529-2.758,1.201-4,2.021V13H7.305 c-0.82,1.242-1.491,2.585-2.021,4H13V26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Greece);
export default __webpack_public_path__ + "static/media/icons8-greece.585626f8e8ce0b0b5863e699c4427e40.svg";
export { ForwardRef as ReactComponent };